/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EarnSocialFollowBody
 */
export interface EarnSocialFollowBody {
    /**
     * 
     * @type {string}
     * @memberof EarnSocialFollowBody
     */
    objectiveTemplateId: string;
    /**
     * 
     * @type {string}
     * @memberof EarnSocialFollowBody
     */
    platform: string;
}

/**
 * Check if a given object implements the EarnSocialFollowBody interface.
 */
export function instanceOfEarnSocialFollowBody(value: object): value is EarnSocialFollowBody {
    if (!('objectiveTemplateId' in value) || value['objectiveTemplateId'] === undefined) return false;
    if (!('platform' in value) || value['platform'] === undefined) return false;
    return true;
}

export function EarnSocialFollowBodyFromJSON(json: any): EarnSocialFollowBody {
    return EarnSocialFollowBodyFromJSONTyped(json, false);
}

export function EarnSocialFollowBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): EarnSocialFollowBody {
    if (json == null) {
        return json;
    }
    return {
        
        'objectiveTemplateId': json['objectiveTemplateId'],
        'platform': json['platform'],
    };
}

export function EarnSocialFollowBodyToJSON(json: any): EarnSocialFollowBody {
    return EarnSocialFollowBodyToJSONTyped(json, false);
}

export function EarnSocialFollowBodyToJSONTyped(value?: EarnSocialFollowBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'objectiveTemplateId': value['objectiveTemplateId'],
        'platform': value['platform'],
    };
}

